import React, { useState, useEffect } from "react";
import ContractList from "../../components/contract-list/ContractList";
import ContratDetails from "../../components/contract-list/ContratDetails";
import "../../assets/css/timesheet.css";
import NavBar from "../../components/general/NavBarApp";
import download from "../../assets/img/ico/download.svg";

// Exemple de données
const contractsData = [
  {
    id: 1,
    date: "Jeu. 30 Mars 2025",
    startDate: "Samedi 2 Avril 2025",
    endDate: "Jeu. 6 Avril 2025",
    name: "Lucas Prochon",
    number: 14732902,
    role: "Cuisinier H/F",
    status: "À SIGNER",
    startTime: "05:30",
    endTime: "13:00",
    breakTime: "00:30",
    workedHours: "07:00",
    workedDays: "4",
  },
  {
    id: 2,
    date: "Ven. 31 Mars 2025",
    startDate: "Dimanche 3 Avril 2025",
    endDate: "Ven. 7 Avril 2025",
    name: "Marie Dupont",
    number: 14732903,
    role: "Serveur H/F",
    status: "SIGNÉ",
    startTime: "06:00",
    endTime: "14:00",
    breakTime: "00:45",
    workedHours: "07:15",
    workedDays: "5",
  },
  {
    id: 3,
    date: "Sam. 1 Avril 2025",
    startDate: "Lundi 4 Avril 2025",
    endDate: "Sam. 8 Avril 2025",
    name: "Jean Martin",
    number: 14732904,
    role: "Plongeur H/F",
    status: "EN ATTENTE",
    startTime: "07:00",
    endTime: "15:00",
    breakTime: "01:00",
    workedHours: "07:00",
    workedDays: "6",
  },
  {
    id: 4,
    date: "Dim. 2 Avril 2025",
    startDate: "Mardi 5 Avril 2025",
    endDate: "Dim. 9 Avril 2025",
    name: "Sophie Bernard",
    number: 14732905,
    role: "Chef H/F",
    status: "À SIGNER",
    startTime: "08:00",
    endTime: "16:00",
    breakTime: "00:30",
    workedHours: "07:30",
    workedDays: "5",
  },
  {
    id: 5,
    date: "Lun. 3 Avril 2025",
    startDate: "Mercredi 6 Avril 2025",
    endDate: "Lun. 10 Avril 2025",
    name: "Paul Morel",
    number: 14732906,
    role: "Barman H/F",
    status: "SIGNÉ",
    startTime: "09:00",
    endTime: "17:00",
    breakTime: "00:45",
    workedHours: "07:15",
    workedDays: "4",
  },
  {
    id: 6,
    date: "Mar. 4 Avril 2025",
    startDate: "Jeudi 7 Avril 2025",
    endDate: "Mar. 11 Avril 2025",
    name: "Emma Leroy",
    number: 14732907,
    role: "Réceptionniste H/F",
    status: "EN ATTENTE",
    startTime: "10:00",
    endTime: "18:00",
    breakTime: "01:00",
    workedHours: "07:00",
    workedDays: "5",
  },
  {
    id: 7,
    date: "Mer. 5 Avril 2025",
    startDate: "Vendredi 8 Avril 2025",
    endDate: "Mer. 12 Avril 2025",
    name: "Hugo Petit",
    number: 14732908,
    role: "Commis H/F",
    status: "À SIGNER",
    startTime: "11:00",
    endTime: "19:00",
    breakTime: "00:30",
    workedHours: "07:30",
    workedDays: "6",
  },
  {
    id: 8,
    date: "Jeu. 6 Avril 2025",
    startDate: "Samedi 9 Avril 2025",
    endDate: "Jeu. 13 Avril 2025",
    name: "Chloé Garnier",
    number: 14732909,
    role: "Manager H/F",
    status: "SIGNÉ",
    startTime: "12:00",
    endTime: "20:00",
    breakTime: "00:45",
    workedHours: "07:15",
    workedDays: "5",
  },
  {
    id: 9,
    date: "Ven. 7 Avril 2025",
    startDate: "Dimanche 10 Avril 2025",
    endDate: "Ven. 14 Avril 2025",
    name: "Nathan Dubois",
    number: 14732910,
    role: "Technicien H/F",
    status: "EN ATTENTE",
    startTime: "13:00",
    endTime: "21:00",
    breakTime: "01:00",
    workedHours: "07:00",
    workedDays: "4",
  },
  {
    id: 10,
    date: "Sam. 8 Avril 2025",
    startDate: "Lundi 11 Avril 2025",
    endDate: "Sam. 15 Avril 2025",
    name: "Léa Fontaine",
    number: 14732911,
    role: "Assistant H/F",
    status: "À SIGNER",
    startTime: "14:00",
    endTime: "22:00",
    breakTime: "00:30",
    workedHours: "07:30",
    workedDays: "6",
  },
];

function ContractListPage() {
  const [selectedContract, setSelectedContract] = useState(contractsData[0]);
  const [contractItems, setContractItems] = useState(contractsData);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
  // Gère le redimensionnement
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1100);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const calculateWorkedHours = (startTime, endTime, breakTime) => {
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const [endHours, endMinutes] = endTime.split(":").map(Number);
    const [breakHours, breakMinutes] = breakTime.split(":").map(Number);

    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const breakTotalMinutes = breakHours * 60 + breakMinutes;

    const workedMinutes =
      endTotalMinutes - startTotalMinutes - breakTotalMinutes;

    const workedHours = Math.floor(workedMinutes / 60);
    const workedMinutesRemainder = workedMinutes % 60;

    return `${String(workedHours).padStart(2, "0")}:${String(
      workedMinutesRemainder
    ).padStart(2, "0")}`;
  };

  const handleUpdateItem = (updatedItem) => {
    const updatedWorkedHours = calculateWorkedHours(
      updatedItem.startTime,
      updatedItem.endTime,
      updatedItem.breakTime
    );

    const updatedTimesheet = {
      ...updatedItem,
      workedHours: updatedWorkedHours,
    };

    setSelectedContract(updatedTimesheet);
    setContractItems((prevItems) =>
      prevItems.map((item) =>
        item.id === updatedTimesheet.id ? updatedTimesheet : item
      )
    );
  };

  const handleDeselect = () => {
    setSelectedContract(null);
  };

  const showList = !isMobile || (isMobile && !selectedContract);
  const showDetails = !isMobile || (isMobile && selectedContract);

  const [selected, setSelected] = useState("Ce mois");
  const [open, setOpen] = useState(false);

  const options = ["90 derniers jours", "6 derniers mois", "Ce mois"];

  const handleSelect = (value) => {
    setSelected(value);
    setOpen(false);
    // ici tu pourrais trier ton tableau offer selon la valeur choisie
  };

  const [selectedDateRange, setSelectedDateRange] = useState(
    "Sam.01 mars.25 - Dim.02 mars.25"
  );

  return (
    <div className="main">
      <NavBar />
      <section className="timesheet-section">
        <div className="financial-header">
          <div className="header-title">
            <h3>Mes contrats</h3>{" "}
            {/* Utilise H1 ou H2 selon la structure globale */}
          </div>

          <div className="header-controls">
            <div className="filter-group">
              <label htmlFor="period-select" className="filter-label">
                Trier par
              </label>

              <div className="custom-dropdown" onClick={() => setOpen(!open)}>
                <button className="custom-dropdown-button">
                  {selected}
                  <i
                    className={`fa-solid fa-chevron-down ${
                      open ? "rotate" : ""
                    }`}
                  ></i>
                </button>

                {open && (
                  <ul className="custom-dropdown-menu">
                    {options.map((option) => (
                      <li
                        key={option}
                        onClick={() => handleSelect(option)}
                        className={`custom-dropdown-item ${
                          selected === option ? "active" : ""
                        }`}
                      >
                        {option}
                        {selected === option && (
                          <i className="fa-solid fa-check check-icon"></i>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="filter-group">
              {/* Placeholder pour le sélecteur de date range */}
              {/* Idéalement, remplace ceci par un composant de date picker */}
              <input
                type="text" // Utilise un type 'date' ou une librairie de date picker
                value={selectedDateRange} // Utilise la prop
                onChange={(e) => setSelectedDateRange(e.target.value)} // Utilise la prop
                // Si état local : value={localSelectedDateRange} onChange={(e) => setLocalSelectedDateRange(e.target.value)}
                className="date-range-picker"
                placeholder="Sélectionner une plage de dates"
              />
              {/* Icône de calendrier ici */}
            </div>

            <div>
              <button className="btn fill green">
                Commander une nouvelle mission
              </button>
              <button className={"btn empty"}>
                Signature multiple de contrat
              </button>
            </div>
          </div>
        </div>
        <div className="timesheet-container">
          {showList && (
            <ContractList
              timesheets={contractsData}
              onSelect={setSelectedContract}
              selectedId={selectedContract?.id}
            />
          )}
          {showDetails && (
            <ContratDetails
              timesheet={selectedContract}
              onUpdate={handleUpdateItem}
              onDeselect={handleDeselect}
            />
          )}
        </div>
      </section>
    </div>
  );
}

export default ContractListPage;
